// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__mIqIk","productName":"Table_productName__1ePY-"};